/**
 * @generated SignedSource<<512afb017027e2e8b64a09dc0e31bce6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterArtSize_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMeasurementUnit_user" | "SbSharedRefineMenuDimensionUnitRadioSelect_user">;
  readonly " $fragmentType": "SbSharedRefineMenuFilterArtSize_user";
};
export type SbSharedRefineMenuFilterArtSize_user$key = {
  readonly " $data"?: SbSharedRefineMenuFilterArtSize_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterArtSize_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterArtSize_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b23e3230d4e68735b9f6151a46c9b762";

export default node;
